import dayjs from 'dayjs'

const SECOND_TIMESTAMP_LIMIT = 1000000000000

const normalizeTimestamp = (value) => {
  if (!value) {
    return null
  }

  const numericValue = Number(value)
  if (!Number.isFinite(numericValue)) {
    return value
  }

  return numericValue < SECOND_TIMESTAMP_LIMIT ? numericValue * 1000 : numericValue
}

const formatTime = (value, format = 'YYYY-MM-DD HH:mm:ss', emptyText = '--') => {
  const timestamp = normalizeTimestamp(value)
  if (timestamp === null) {
    return emptyText
  }

  const time = dayjs(timestamp)
  if (!time.isValid()) {
    return emptyText
  }

  return time.format(format)
}

export default formatTime
